import type { IconSvgObject } from './types';

const ReceiptEuroIcon: IconSvgObject = [
  ["path", { d: "M9.5 2L12 3.5L14.5 2L17 3.5L20 2V22L17 20.5L14.5 22L12 20.5L9.5 22L7 20.5L4 22V2L7 3.5L9.5 2Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14.5 9.5C14 8.5 13.1936 8 12.1056 8C10.6665 8 9.5 9.16655 9.5 10.6056V13.3944C9.5 14.8335 10.6665 16 12.1056 16C13.1936 16 14 15.5 14.5 14.5M8 12H12.1056", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ReceiptEuroIcon;
